import * as yup from 'yup';

export const CreatePaymentTypeFormValidation = yup.object().shape({
    description: yup.string().required('Descrição é obrigatória'),
    amount: yup.number().typeError("deve ser valor").required('Tipo pagamento é obrigatória'),
});